export default {
  getMenuList: '/api/routes/getMenuList', //获取菜单列表
  getPlatformList: '/api/routes/getPlatformsList', // 获取平台列表
  addRoutes: '/api/routes/addRoutes', // 新增菜单节点
  editRoutes: '/api/routes/editRoutes', // 编辑菜单节点
  delRoutes: '/api/routes/delRoutes', // 删除菜单节点
};
